import { render } from "./Episode.vue?vue&type=template&id=564e5748&scoped=true"
import script from "./Episode.vue?vue&type=script&lang=js"
export * from "./Episode.vue?vue&type=script&lang=js"

import "./Episode.vue?vue&type=style&index=0&id=564e5748&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564e5748"]])

export default __exports__